import React, { useState } from 'react';
import { Field } from 'redux-form';
import { Col } from 'react-bootstrap';
import { isBroker } from '../../../../auth/redux/authActions';
import { OverrideFormControl } from '../../../../../common/components';

const MtaPremiumOverride = ({
  selectedPremium,
  handleGrossOverride,
  isPremiumAdjusting,
  isMta,
}) => {
  const [value, setValue] = useState();
  if (!isMta || isBroker() || !selectedPremium) {
    return null;
  }

  const hasErrors =
    (!!selectedPremium.errors && !!selectedPremium.errors.length) ||
    (!!selectedPremium.declines && !!selectedPremium.declines.length);
  if (hasErrors) {
    return null;
  }

  const oldGross = selectedPremium.mta.old_premium?.gross;

  const toNewPremium = (val) => {
    setValue(val);
    return oldGross + parseFloat(val);
  };

  const fromNewPremium = () => {
    return value;
  };

  return (
    <Col xs={12} className="admin-fee-container">
      <h4 className="text-center">Override MTA Premium</h4>
      <Field
        name={'data.attributes.metadata.overrides.gross_premium'}
        parse={toNewPremium}
        format={fromNewPremium}
        currency
        labelSize={2}
        placeholder={`${selectedPremium.premium.gross}`}
        component={OverrideFormControl}
        isCalc={isPremiumAdjusting}
        className="text-right"
        handleApplyButton={handleGrossOverride}
      />
    </Col>
  );
};
export default MtaPremiumOverride;
